import { User } from '../../models/user.model';
import { LoginData, FixaResource, SelectedContractDetails } from '../../models/login.model';

export interface UserState {
  // Dados de autenticação
  auth: {
    isAuthenticated: boolean;
    loginData: LoginData | null;
  };

  currentUser: User | null;
  loading: boolean;
  error: string | null;
  lastUpdated: number | null;

  selectedContract: FixaResource | null;
  selectedContractDetails: SelectedContractDetails | null;
}

export const initialState: UserState = {
  auth: {
    isAuthenticated: false,
    loginData: null,
  },
  currentUser: null,
  loading: false,
  error: null,
  lastUpdated: null,
  selectedContract: null,
  selectedContractDetails: null,
};
